/**
 * InkQuote Data Adapters
 * Transform InkQuote API responses into formats compatible with existing card components
 */

export const inkquoteToTweet = (quote) => {
  const metadata = typeof quote.metadata === 'string'
    ? JSON.parse(quote.metadata)
    : quote.metadata || {};

  // Construct tweet URL from tweet_id and screen_name if not provided
  let tweetUrl = metadata.tweet_url || metadata.url;
  if (!tweetUrl || tweetUrl === '#') {
    const tweetId = metadata.tweet_id || quote.quote_id || quote.id;
    const screenName = metadata.screen_name || 'twitter';
    tweetUrl = `https://twitter.com/${screenName}/status/${tweetId}`;
  }

  return {
    id: quote.quote_id || quote.id,
    text: quote.content,
    full_text: quote.content,
    created_at: quote.created_at || quote.displayed_at,
    user: {
      name: quote.author || metadata.author || 'Unknown',
      screen_name: metadata.screen_name || 'unknown',
      profile_image_url: metadata.profile_image || '/default-profile-pic.png'
    },
    url: tweetUrl,
    medias: metadata.medias || [],
    source: 'like', // All tweets from InkQuote API are likes
    retweet_count: metadata.engagement?.retweets || 0,
    reply_count: metadata.engagement?.replies || 0,
    like_count: metadata.engagement?.likes || 0,
    skip: quote.skip,
    skipCategories: quote.skip_categories || quote.metadata?.skipCategories || [],
    _inkquote_id: quote.quote_id || quote.id // Preserve original ID for API updates
  };
};

export const inkquoteToRoam = (quote) => {
  const metadata = typeof quote.metadata === 'string'
    ? JSON.parse(quote.metadata)
    : quote.metadata || {};

  return {
    id: quote.quote_id || quote.id,
    text: quote.content,
    content: quote.content,
    created_at: quote.created_at || quote.displayed_at,
    author: quote.author,
    source: 'inkquote_roam',
    metadata: {
      page_title: metadata.page_title || 'InkQuote',
      original_id: metadata.original_id || metadata.page_uid,
      source_url: metadata.source_url || '',
      create_time: new Date(quote.created_at || quote.displayed_at).getTime()
    },
    skip: quote.skip,
    skipCategories: quote.skip_categories || quote.metadata?.skipCategories || [],
    _inkquote_id: quote.quote_id || quote.id
  };
};

export const inkquoteToManual = (quote) => {
  const metadata = typeof quote.metadata === 'string'
    ? JSON.parse(quote.metadata)
    : quote.metadata || {};

  return {
    id: quote.quote_id || quote.id,
    content: quote.content,
    author: quote.author || 'Unknown',
    created_at: quote.created_at || quote.displayed_at,
    source: 'inkquote_manual',
    tags: metadata.tags || [],
    skip: quote.skip,
    skipCategories: quote.skip_categories || quote.metadata?.skipCategories || [],
    _inkquote_id: quote.quote_id || quote.id
  };
};

/**
 * Main adapter function - routes to appropriate adapter based on source
 */
export const adaptInkQuote = (quote) => {
  switch (quote.source) {
    case 'twitter':
      return { type: 'tweet', data: inkquoteToTweet(quote) };
    case 'roam':
      return { type: 'roam', data: inkquoteToRoam(quote) };
    case 'manual':
      return { type: 'manual', data: inkquoteToManual(quote) };
    default:
      console.warn('Unknown InkQuote source:', quote.source);
      return { type: 'manual', data: inkquoteToManual(quote) };
  }
};
